import React, { useState } from 'react';
import {
  Box, MenuItem, Menu, Typography,
  useMediaQuery, useTheme, Button,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Pipo from '../files/icons/Pipo';

export default function PipoMenu({ rsvpSection, contactSection }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [langMenuAnchorEl, setLangMenuAnchorEl] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const { t, i18n } = useTranslation();

  const open = Boolean(anchorEl);
  const langMenuOpen = Boolean(langMenuAnchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLangClick = (event) => {
    setLangMenuAnchorEl(event.currentTarget);
  };

  const handleLangClose = () => {
    setLangMenuAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    handleLangClose();
  };

  const scrollToRef = (ref) => {
    window.scrollTo({
      top: ref.current.offsetTop - 30,
      behavior: 'smooth',
    });
  };

  // eslint-disable-next-line no-promise-executor-return
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth',
    });
  };

  const handleContactClick = async () => {
    if (location.pathname === '/' && contactSection) {
      scrollToRef(contactSection);
    } else if (contactSection) {
      navigate('/');
      await sleep(500);
      scrollToRef(contactSection);
    } else {
      navigate('/');
    }
    handleClose();
  };

  const handleWeddingClick = () => {
    navigate('/wedding');
    handleClose();
  };

  const handleHomeClick = () => {
    navigate('/');
    handleClose();
  };

  const handlePlaylistClick = () => {
    navigate('playlist');
    handleClose();
  };

  const handleCagnotteClick = () => {
    window.open('https://www.onparticipe.fr/c/paulineetpierre', '_blank');
    handleClose();
  };

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: { xs: 0, md: 20 },
          right: { xs: 5, md: 30 },
          cursor: 'pointer',
          zIndex: 1000,
          p: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Box onClick={handleClick} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Pipo width={isLargeScreen ? '50' : '40'} />
          <Typography variant="caption">MENU</Typography>
        </Box>
        <Button
          variant="text"
          size="small"
          onClick={handleLangClick}
          sx={{ color: 'terracota.main', minWidth: 'auto' }}
        >
          {(i18n.language || 'fr').toUpperCase()}
        </Button>
      </Box>

      <Menu
        id="positioned-menu"
        aria-labelledby="positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {location.pathname !== '/' && (
          <MenuItem onClick={handleHomeClick}>{t('menu.home')}</MenuItem>
        )}
        <MenuItem onClick={handlePlaylistClick}>{t('menu.playlist')}</MenuItem>
        <MenuItem onClick={() => navigate('/gallery')}>{t('menu.gallery')}</MenuItem>
        <MenuItem onClick={handleCagnotteClick}>{t('menu.cagnotte')}</MenuItem>
        <MenuItem onClick={handleContactClick}>{t('menu.contact')}</MenuItem>
        <MenuItem
          onClick={handleWeddingClick}
          sx={{ color: 'rgba(0, 0, 0, 0.5)' }}
        >
          {t('menu.wedding')}
        </MenuItem>
      </Menu>

      <Menu
        anchorEl={langMenuAnchorEl}
        open={langMenuOpen}
        onClose={handleLangClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={() => changeLanguage('fr')}>FR</MenuItem>
        <MenuItem onClick={() => changeLanguage('en')}>EN</MenuItem>
        <MenuItem onClick={() => changeLanguage('de')}>DE</MenuItem>
      </Menu>
    </>
  );
}
